import request from '@/plugin/axios'

export function queryQuotaRecordListByPage (data) {
  return request({
    url: '/api/admin/queryQuotaRecordListByPage',
    method: 'get',
    params: data
  })
}
export function setChildBusinessQuota (data) {
  return request({
    url: '/api/admin/setChildBusinessQuota',
    method: 'post',
    data: data
  })
}
export function updateChildBusinessQuotaRecord (data) {
  return request({
    url: '/api/admin/updateChildBusinessQuotaRecord',
    method: 'post',
    data: data
  })
}
